import { keyframes, styled } from 'styled-components'

import { Modal } from '@/components/ui/modal'
import { ModalBody } from '@/components/ui/modal/modal.styled'
import { Radio } from '@/components/ui/radio'
import { RadioBox, RadioIndicator } from '@/components/ui/radio/radio.styled'

export const BrowseModal = styled(Modal)`
  && {
    width: 51.8rem;
    max-width: 51.8rem;
    height: 58.8rem;
    max-height: 58.8rem;
  }

  ${ModalBody} {
    overflow-y: auto;
  }
`

export const SearchWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space[16]};
`

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 22.6rem);
  gap: ${({ theme }) => theme.space[16]};
`

export const ImageCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ImageTile = styled.button<{ $selected: boolean }>`
  padding: 0;
  border: ${({ theme }) => theme.border.size['2']} solid
    ${({ theme, $selected }) => ($selected ? theme.colors.black800 : 'transparent')};
  border-radius: ${({ theme }) => theme.border.radius[8]};
  overflow: hidden;
  cursor: pointer;
  background: none;
  outline: none;
  position: relative;
  width: 100%;
  transition: border-color ${({ theme }) => theme.transition.duration.sm} ease;

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.black800};
  }
`

export const RadioWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  right: ${({ theme }) => theme.space[8]};
  top: ${({ theme }) => theme.space[8]};
`

export const ImageRadio = styled(Radio)`
  ${RadioBox} {
    height: 2rem;
    width: 2rem;
  }

  ${RadioIndicator} {
    height: 1rem;
    width: 1rem;
  }
`

export const Thumbnail = styled.img`
  width: 22.6rem;
  height: 12.8rem;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
`

export const DescriptionWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space[4]};
  width: 100%;
  overflow: hidden;
`

const shimmer = keyframes`
  0% { background-position: -100rem 0; }
  100% { background-position: 100rem 0; }
`
// TODO replace with skeleton component from ui/
export const SkeletonTile = styled.div`
  width: 22.6rem;
  height: 12.8rem;
  border-radius: ${({ theme }) => theme.border.radius[8]};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.gray300} 25%,
    ${({ theme }) => theme.colors.gray200} 50%,
    ${({ theme }) => theme.colors.gray300} 75%
  );
  background-size: 200rem 100%;
  animation: ${shimmer} 1.4s infinite linear;
`

export const EmptyStateWrapper = styled.div`
  padding: ${({ theme }) => theme.space[32]} 0;
`

export const FooterWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`
